export class Constants {

  /**
   * Default request headers
   */
  public static readonly DEFAULT_REQUEST_HEADERS = {
    'content-type': 'application/json'
  };

  /**
   * Redirects Paths
   */
  public static readonly REDIRECT_LOGIN_PATH = '/login?returnUrl=/links/tickets-passes';

  /**
   * App routes
   */
  public static readonly ROUTE_LINKS = '';
  public static readonly ROUTE_ASSIGN = 'assign';
  public static readonly ROUTE_CONFIRM = 'confirm';

  /**
   * DScribe resource bundle
   */
  public static readonly RESOURCE_BUNDLE_PREFIX = 'dlr.site.cmsResourceBundle.claim-spa.';

  /**
   * Common translation keys
   */
  public static readonly GENERIC_ERROR = 'genericError';
  public static readonly VALIDATE_GENERIC_ERROR = 'validate-generic';

  /**
   * Carousel keys
   */
  public static readonly CAROUSEL_REGEX = /dlr\.site\.cmsResourceBundle\.claim-spa\.carousel\.slide-[0-9]{1,3}\.image/;
  public static readonly CAROUSEL_IMAGE_KEY = 'carousel.slide-%s.image';
  public static readonly CAROUSEL_ALTTEXT_KEY = 'carousel.slide-%s.alt';

  /**
   * What's next data
   */
  public static readonly WHATS_NEXT_REGEX =
    /dlr\.site\.cmsResourceBundle\.claim-spa\.confirmation-page\.whats-next\.content-block-[0-9]{1,3}\.title/;
  public static readonly WHATS_NEXT_TITLE_KEY = 'confirmation-page.whats-next.content-block-%s.title';
  public static readonly WHATS_NEXT_DESCRIPTION_KEY = 'confirmation-page.whats-next.content-block-%s.description';
  public static readonly WHATS_NEXT_ICON_KEY = 'confirmation-page.whats-next.content-block-%s.icon';
  public static readonly WHATS_NEXT_LINK_KEY = 'confirmation-page.whats-next.content-block-%s.link';

  /**
   * HTTP request types
   */
  public static readonly REQUEST_TYPE_GET = 'get';
  public static readonly REQUEST_TYPE_POST = 'post';

  /**
   * Cookie names
   */
  public static readonly COOKIE_LOCALE = 'localeCookie_jar_aka';
  public static readonly COOKIE_LANGUAGE = 'languageSelection_jar_aka';
  public static readonly COOKIE_CONVERSATION_ID = 'PHPSESSID';

  /**
   * Response Codes
   */
  public static readonly TICKET_LINKED = 2001;
  public static readonly TICKET_UNLINKED = 2000;
  public static readonly TICKET_NOT_FOUND = 30001;

  /**
   * Entitlement types
   */
  public static readonly ENTITLEMENT_TICKETS = 'ThemePark';
  public static readonly ENTITLEMENT_PASS = 'AnnualPass';

  /**
   * Entitlement Guest types
   */
  public static readonly GUEST_PRIMARY = 'PRIMARY';
  public static readonly GUEST_SHARED = 'SHARED';

  /**
   * Entitlement icons
   */
  public static readonly ICON_PASSES = 'di-disneyland-annual-passes';
  public static readonly ICON_TICKETS = 'di-tickets';

  /**
   * Validators keys
   */
  public static readonly DIRTY_WORD_FOUND = 'dirtyWordFound';

  /**
   * Default language
   */
  public static readonly DEFAULT_LANGUAGE = 'en-us';

  /**
   * Locale map
   */
  public static readonly LOCALE_MAP = {
    'en_US': 'en-us',
    'es_US': 'es-us',
    'en_CA': 'en-ca'
  };

  /**
   * Profile and affiliation data
   */
  public static readonly PROFILE_ENDPOINT = '/com-shared/api/get-profile/';
  public static readonly PROFILE_AUTH_HEADER = 'x-disney-internal-commerce-unauth-override';
  public static readonly PROFILE_SWID_HEADER = 'swid';
  public static readonly MEP_AFFILIATION = 'MAIN_ENTRANCE_PASS';
}
